import { css } from '@microsoft/fast-element';
import { genericFormStyling, scrollbarStyles } from '../../../../styles';

export const EditUserModalStyles = css`
  ${scrollbarStyles}
  ${genericFormStyling}
  .edit-user-modal-content {
    height: calc(100% - 155px);
    overflow: auto;
    padding: 16px;
  }

  zero-text-field, zero-select {
    width: 100%;
  }
`;
